import { render, staticRenderFns } from "./option-items-setting.vue?vue&type=template&id=c4110444&scoped=true"
import script from "./option-items-setting.vue?vue&type=script&lang=js"
export * from "./option-items-setting.vue?vue&type=script&lang=js"
import style0 from "./option-items-setting.vue?vue&type=style&index=0&id=c4110444&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4110444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4110444')) {
      api.createRecord('c4110444', component.options)
    } else {
      api.reload('c4110444', component.options)
    }
    module.hot.accept("./option-items-setting.vue?vue&type=template&id=c4110444&scoped=true", function () {
      api.rerender('c4110444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/option-items-setting.vue"
export default component.exports